$(".byob-tier-card").on("click",function(){
    $(".byob-tier-card").removeClass("tc-selected");
    $(this).addClass("tc-selected");
    byobUpdateContent();

    $(".byob-step-num").removeClass("done");
    $(".byob-step-num").removeClass("active");

    $(".byob-sb-num, .byob-sb-item").removeClass("sb-active");
    $(".byob-sb-num, .byob-sb-item").removeClass("sb-done");
    
});

function byobUpdateContent(){
    $(".byob-fc-ctrl").find(".byob-fc-num").text(0);
    var $totalqty = 0;
    $(".byob-flavor-grid .byob-flavor-card").each(function(){
        $totalqty = $totalqty + parseInt($(this).find(".byob-fc-num").text());
    });
    var $bars = parseInt($(".tc-selected").attr("data-bars"));
    var $asp = $(".tc-selected").attr("data-as");
    var $otp = $(".tc-selected").attr("data-ot");
    var $pbasp = $(".tc-selected").attr("data-pbas");
    var $pbotp = $(".tc-selected").attr("data-pbot");
    var $tsave = $(".tc-selected").attr("data-save");
    var $perce = ($totalqty * 100)/$bars;

    $("#byob-bar-count").text($bars);
    $("#byob-psub-price").text($asp);
    $("#byob-pot-price").text($otp);
    $("#byob-psub-perbar").text($pbasp);
    $("#byob-pot-perbar").text($pbotp);
    $("#byob-psub-save").text($tsave);


    $("#byob-prog-count").text(0);
    $("#byob-prog-fill").width("0%");
    $("#byob-prog-of").text("of "+$bars+" total");

    
    $("#byob-sticky-tier-label").text($bars+" bars");
    $("#byob-sticky-prog-label").text($bars);
    $("#byob-sticky-btn-label span").text($bars);
    $("#sticky-bar-count").text(0);
    $("#byob-sticky-prog-fill").width("0%");
    $("#byob-sticky-prog-fill").removeClass("full");
    $(".byob-prog-fill").removeClass("full");
    

    if ($('.byob-tier-card.tc-selected').attr('data-card-type') == "auto-ship"){
        $("#byob-sticky-price").text($asp);
        $("#byob-sticky-price-sub").text("per month · AutoShip");
    }else{
        $("#byob-sticky-price").text($otp);
        $("#byob-sticky-price-sub").text("one-time · no commitment");
    }

    var $penqty = $bars - $totalqty;
    $("#byob-sticky-btn-label").html("<span>"+$penqty+"</span> bars remaining");
    $("#byob-sticky-btn").prop("disabled", true);
    $(".byob-sticky-prog-label").removeClass("done");
};

function byobUpdateSubContent() {
    var $totalqty = 0;
    $(".byob-flavor-grid .byob-flavor-card").each(function(){
        $totalqty = $totalqty + parseInt($(this).find(".byob-fc-num").text());
    });

    var $bars = parseInt($(".tc-selected").attr("data-bars"));
    var $asp = $(".tc-selected").attr("data-as");
    var $otp = $(".tc-selected").attr("data-ot");
    var $tsave = $(".tc-selected").attr("data-save");
    var $perce = ($totalqty * 100)/$bars;

    $("#byob-prog-count").text($totalqty);
    $("#byob-prog-fill").width($perce+"%");

    $("#byob-sticky-tier-label").text($bars+" bars");
    $("#byob-sticky-prog-label").text($bars);
    $("#byob-sticky-btn-label span").text($bars);
    $("#sticky-bar-count").text($totalqty);
    $("#byob-sticky-prog-fill").width($perce+"%");

    if ($('.byob-tier-card.tc-selected').attr('data-card-type') == "auto-ship"){
        $("#byob-sticky-price").text($asp);
        $("#byob-sticky-price-sub").text("per month · AutoShip");
    }else{
        $("#byob-sticky-price").text($otp);
        $("#byob-sticky-price-sub").text("one-time · no commitment");
    }

    var $penqty = $bars - $totalqty;
    if($penqty == 0){

        if ($('.byob-tier-card.tc-selected').attr('data-card-type') == "auto-ship"){
            $("#byob-sticky-btn-label").text("CHECKOUT - "+$asp);
        }else{
            $("#byob-sticky-btn-label").text("CHECKOUT - "+$otp);
        }

        $("#byob-sticky-prog-fill,.byob-prog-fill").addClass("full");
        $(".byob-sticky-prog-label").addClass("done");
        $("#byob-sticky-btn").prop("disabled", false);
    }else{
        $("#byob-sticky-btn-label").html("<span>"+$penqty+"</span> bars remaining");
        $("#byob-sticky-btn").prop("disabled", true);
        $("#byob-sticky-prog-fill,.byob-prog-fill").removeClass("full");
        $(".byob-sticky-prog-label").removeClass("done");
    }
};


$(".byob-dec-btn").on("click", function() {
    var $totalqty = 0;
    var $bars = parseInt($(".tc-selected").attr("data-bars"));
    $(".byob-flavor-grid .byob-flavor-card").each(function(){
        $totalqty = $totalqty + parseInt($(this).find(".byob-fc-num").text());
    });
   var $dec = parseInt($(this).parent(".byob-fc-ctrl").find(".byob-fc-num").text());
   if($dec > 0){
     $dec = $dec - 10;
     $totalqty = $totalqty - 10;
   }
   $(this).parent(".byob-fc-ctrl").find(".byob-fc-num").text($dec);
   byobUpdateSubContent();
});

$(".byob-inc-btn").on("click", function() {
    var $totalqty = 0;
    var $bars = parseInt($(".tc-selected").attr("data-bars"));
    $(".byob-flavor-grid .byob-flavor-card").each(function(){
        $totalqty = $totalqty + parseInt($(this).find(".byob-fc-num").text());
    });
    var $inc = parseInt($(this).parent(".byob-fc-ctrl").find(".byob-fc-num").text());
    if($bars != $totalqty){
        $inc = $inc + 10;
        $totalqty = $totalqty + 10;
    }
    $(this).parent(".byob-fc-ctrl").find(".byob-fc-num").text($inc);
    byobUpdateSubContent();
});

$("#byob-sticky-btn").on('click', function (e) {
    $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        success: function () {
            
        Shopify.queue = [];
        $(".byob-flavor-grid").find(".byob-flavor-card").each(function(){
            if(parseInt($(this).find(".byob-fc-num").text()) > 0){
                var $vsid = parseInt($(this).attr("data-subscription-id"));
                var $vid = parseInt($(this).attr("data-id"));
                var $vqty = parseInt($(this).find(".byob-fc-num").text()) / 10;

                Shopify.queue.push({
                    sellingPlan: $vsid,
                    variantId: $vid,
                    quantity: $vqty,
                })
            }
        });
        Shopify.moveAlong = function() {
            if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            if ($('.byob-tier-card.tc-selected').attr('data-card-type') == "auto-ship"){
                var data = 'id='+request.variantId+'&quantity='+request.quantity+'&selling_plan='+request.sellingPlan;
            }else{
                var data = 'id='+ request.variantId + '&quantity='+request.quantity;
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res){
                Shopify.moveAlong();
                },
                error: function(){
                if (Shopify.queue.length){
                    Shopify.moveAlong();
                } else {
                }
                }
            });
            }else{
                window.location.href = '/checkout';
            }
        };
        Shopify.moveAlong();
        },

        error: function () {
            console.error('Failed to clear cart');
        }
    });
})


$(".byob-tier-grid, .byob-step-wrap").on("click", function() {
    var $totalqty = 0;
    $(".byob-flavor-grid .byob-flavor-card").each(function(){
        $totalqty = $totalqty + parseInt($(this).find(".byob-fc-num").text());
    });
    var $bars = parseInt($(".tc-selected").attr("data-bars"));
    
    var $step1off = parseInt($('#byob-step-1-wrap').offset().top - 188);
    var $step2off = parseInt($('#byob-step-2-wrap').offset().top - 188);

    var $penqty = $bars - $totalqty;
    var $id = $(this).attr('id');

    if($id == "byob-step-1-wrap"){
        $('html, body').animate({
            scrollTop: $step2off
        }, 600);
    }
});

$(window).on('scroll', function() {
   var $scrollTop = $(window).scrollTop();
   var $step1off = parseInt($('#byob-step-1-wrap').offset().top - 190);
   var $step2off = parseInt($('#byob-step-2-wrap').offset().top - 190);

   if($scrollTop > $step1off){
        $("#byob-sn2.byob-step-num").removeClass("active");
        $("#byob-sn2.byob-step-num").removeClass("done");
        $("#byob-sn1.byob-step-num").removeClass("done");
        $("#byob-sn1.byob-step-num").addClass("active");

        $("#byob-sb-num-2.byob-sb-num, #byob-sb-item-2.byob-sb-item").removeClass("sb-active");
        $("#byob-sb-num-2.byob-sb-num, #byob-sb-item-2.byob-sb-item").removeClass("sb-done");
        $("#byob-sb-num-1.byob-sb-num, #byob-sb-item-1.byob-sb-item").removeClass("sb-done");
        $("#byob-sb-num-1.byob-sb-num, #byob-sb-item-1.byob-sb-item").addClass("sb-active");
   }

   if($scrollTop > $step2off){
        $("#byob-sn1.byob-step-num").removeClass("active");
        $("#byob-sn1.byob-step-num").addClass("done");
        $("#byob-sn2.byob-step-num").removeClass("done");
        $("#byob-sn2.byob-step-num").addClass("active");

        $("#byob-sb-num-1.byob-sb-num, #byob-sb-item-1.byob-sb-item").removeClass("sb-active");
        $("#byob-sb-num-1.byob-sb-num, #byob-sb-item-1.byob-sb-item").addClass("sb-done");
        $("#byob-sb-num-2.byob-sb-num, #byob-sb-item-2.byob-sb-item").removeClass("sb-done");
        $("#byob-sb-num-2.byob-sb-num, #byob-sb-item-2.byob-sb-item").addClass("sb-active");
   }
});